import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, Container, UncontrolledTooltip } from 'reactstrap';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from 'components/Common/TableContainer';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { getUserListForCallAvailabilityAPIURL } from 'BaseComponentAPI/CallAvailability';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import { getEmpWorkingShiftsAPIURL } from 'BaseComponentAPI/WorkingShiftsAPI';
import Spinners from 'components/Common/Spinner';
import PopupWindow from 'components/Common/PopupWindow';
import Loader from 'components/Common/Loader';
import { checkPermissions } from 'components/Common/ChkPermissions';
import CantAccessPage from 'components/Common/CantAccessPage';

const WorkingShifts = () => {
    const authUser = useSelector(state => state.Login);
    // console.log(JSON.stringify(authUser))

    const navigate = useNavigate();

    const storedPermissions = JSON.parse(localStorage.getItem('permissions')) || {};
    const { canRead, canCreate, canChange } = checkPermissions(storedPermissions);

    document.title = "Cockpit";


    const [loaderOption, setLoaderOption] = useState(false);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');  // Set the message from passed state
    const [popupType, setPopupType] = useState('');  // Set the type from passed state

    const openPopup = (message, type) => {
        setPopupMessage(message);
        setPopupType(type);
        setIsPopupVisible(true);
    };

    const closePopup = () => {
        setIsPopupVisible(false);
    };


    const columns = useMemo(
        () => [
            {
                header: "User Name",
                accessorKey: "userName",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "User Role",
                accessorKey: "userRole",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Working Status",
                accessorKey: "currentStatus",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => {
                    const status = cell.getValue();
                    let dotColor = '';

                    switch (status) {
                        case "1":
                            dotColor = 'green';
                            break;
                        case "2":
                            dotColor = 'yellow';
                            break;
                        case "3":
                            dotColor = 'red';
                            break;
                        case "4":
                            dotColor = 'gray';
                            break;
                        default:
                            dotColor = 'white';
                    }

                    return (
                        <div
                            style={{
                                width: '12px',
                                height: '12px',
                                borderRadius: '50%',
                                backgroundColor: dotColor,
                                // border:'1px solid grey'
                            }}
                        />
                    );
                },
            },
            {
                header: "Is Today Working",
                accessorKey: "isWorkingDay",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Is Shift 1 Assigned",
                accessorKey: "isShift1Assigned",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Shift 1 In Time",
                accessorKey: "shift1InTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Shift 1 Out Time",
                accessorKey: "shift1OutTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Actual Shift 1 Sign In Time",
                accessorKey: "actualShift1SignInTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Is Shift 2 Assigned",
                accessorKey: "isShift2Assigned",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Shift 2 In Time",
                accessorKey: "shift2InTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Shift 2 Out Time",
                accessorKey: "shift2OutTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Actual Shift 2 Sign In Time",
                accessorKey: "actualShift2SignInTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Is Shift 3 Assigned",
                accessorKey: "isShift3Assigned",
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ cell }) => (cell.getValue() === 1 ? "Yes" : "No"),
            },
            {
                header: "Shift 3 In Time",
                accessorKey: "shift3InTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Shift 3 Out Time",
                accessorKey: "shift3OutTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Actual Shift 3 Sign In Time",
                accessorKey: "actualShift3SignInTime",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: true,
                cell: cellProps => {
                    const isDisabled = cellProps.row.original.userShiftUUID === "";
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        // navigate(`/ChangeUserCallAvailability/${cellProps.row.original.userUUID}`);
                                        if (!isDisabled) {
                                            //console.log("aaaaa")
                                        }
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                    aria-disabled={isDisabled || !canChange}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    {!isDisabled && (
                                        <UncontrolledTooltip
                                            placement="top"
                                            target={`edittooltip-${cellProps.row.original.id}`}
                                            timeout={150}
                                        >
                                            Edit
                                        </UncontrolledTooltip>
                                    )}
                                </Link>

                            </li>

                        </ul>
                    );
                },
            },
        ],
        []
    );


    const [data, setData] = useState([]);


    const [pageNo, setPageNo] = useState(1);  // Track the current page number
    const [pageSize, setPageSize] = useState(10);  // Track page size
    const [totalPages, setTotalPages] = useState('');
    const [totalItems, setTotalItems] = useState('');
    const [nextPage, setNextPage] = useState('');
    const [previousPage, setPreviousPage] = useState('');
    const [currentPage, setCurrentPage] = useState('');
    const customePageSize = [10, 20, 30, 40, 50]
    const [workingData, setWorkingData] = useState({});


    useEffect(() => {
        if (!canRead) {
            openPopup('Something went wrong!', 'error')
        }
        else {
            getData();
        }

    }, [authUser]);

    const getData = async () => {
        setLoaderOption(true);
        setData([]);
        setTotalPages('');
        setTotalItems('');
        setNextPage('');
        setPreviousPage('');
        setCurrentPage('');

        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(JSON.stringify(authUser.headers))
            // console.log(`${getEmpWorkingShiftsAPIURL}?userUUID=${authUser.headers.userUUID}`)
            try {
                const response = await axios.get(
                    `${getEmpWorkingShiftsAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${pageNo}&perPageRec=${pageSize}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.weekShiftDetails);
                    setWorkingData(response.data.data.officeWorkingDetails)
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                }
                else {
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                    console.error('API Response Error:', response.data.responseMsg);
                }
            } catch (error) {
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
                console.error('Error fetching data:', JSON.stringify(error));
            }
            //  finally {
            //     setLoaderOption(false);
            // }
        }
    };

    const handlePageChange = async (newPageNo, newPageSize) => {
        if (authUser.headers && Object.keys(authUser.headers).length > 0) {
            // console.log(JSON.stringify(authUser.headers))
            // console.log(`${getEmpWorkingShiftsAPIURL}?userUUID=${authUser.headers.userUUID}`)
            try {
                const response = await axios.get(
                    `${getEmpWorkingShiftsAPIURL}?userUUID=${authUser.headers.userUUID}&isPagination=1&pageNo=${newPageNo}&perPageRec=${newPageSize}`,
                    {
                        headers: { ...authUser.headers },
                        'Authorization': `Bearer ${authUser.headers.access_token}`
                    }
                );

                if (response.data.responseMsg === "Success") {
                    setData(response.data.data.weekShiftDetails);
                    setWorkingData(response.data.data.officeWorkingDetails)
                    setTotalPages(response.data.data.totalPages)
                    setTotalItems(response.data.data.totalItems);
                    setNextPage(response.data.data.nextPage);
                    setPreviousPage(response.data.data.previousPage);
                    setCurrentPage(response.data.data.currentPage);
                    setLoaderOption(false);
                }
                else {
                    setLoaderOption(false);
                    openPopup(response.data.responseMsg, 'error')
                    console.error('API Response Error:', response.data.responseMsg);
                }
            } catch (error) {
                setLoaderOption(false);
                openPopup("Requested Data Not Found / 404", 'warn')
                console.error('Error fetching data:', JSON.stringify(error));
            }
            //  finally {
            //     setLoaderOption(false);
            // }
        }
    };

    if (!canRead) {
        return (
            <>
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Cold Calls" breadcrumbItem="Upload Cold Calls" />
                            <CantAccessPage />
                        </Container>
                    </div>
                </React.Fragment>
            </>
        )
    }
    else {
        if (loaderOption == true) {
            return (
                <>
                    <Loader />
                </>
            )
        }
        else {
            return (
                <React.Fragment>
                    <div className="page-content">
                        <Container fluid>
                            <Breadcrumbs title="Users" breadcrumbItem="Working Shifts" />
                            <Card>
                                <CardBody>
                                    {data && workingData && (
                                        <div className='mt-3'>
                                            {/* <div className="d-flex align-items-center justify-content-end">
                                                <div className="flex-shrink-0">
                                                    <Link
                                                        to="#"
                                                        // onClick={() => setModal(true)}
                                                        className="btn btn-primary me-1"
                                                    >
                                                        Export Excel
                                                    </Link>
                                                </div>
                                            </div> */}
                                            {/* Today Is Monday & is Working Day. Office Time is 09:00:00 To 20:00:00 */}
                                            <h5
                                                className="mt-1"
                                                style={{ justifyContent: 'center', display: 'flex', flexWrap: 'wrap' }}
                                            >
                                                Today is <span style={{ color: '#261eaf', margin: '0 4px' }}>{workingData.weekDay}</span>
                                                & it is <span style={{ color: '#261eaf', margin: '0 4px' }}>{workingData.isWorkingDay === 1 ? 'a working day' : 'a non-working day'}</span>.
                                                Office time is <span style={{ color: '#261eaf', margin: '0 4px' }}>{workingData.startTime}</span>
                                                to <span style={{ color: '#261eaf', margin: '0 4px' }}>{workingData.endTime}</span>.
                                            </h5>


                                            <div className='mt-4'>
                                                <TableContainer
                                                    columns={columns}
                                                    data={data || []}
                                                    isGlobalFilter={true}
                                                    isPagination={true}
                                                    SearchPlaceholder="Search..."
                                                    isCustomPageSize={true}
                                                    tableClass="align-middle table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                                                    theadClass="table-light"
                                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                                    pagination="pagination"
                                                    getRowProps={row => ({
                                                        className: `${row.original.userShiftUUID === "" ? "is-nouserid" : ""
                                                            }`,
                                                    })}
                                                    onPageChange={handlePageChange} // Pass page change handler
                                                    onPageSizeChange={handlePageChange} // Pass page size change handler
                                                    pageSize={pageSize}
                                                    setPageSize={setPageSize}
                                                    totalPages={totalPages}
                                                    totalItems={totalItems}
                                                    tableNextPage={nextPage}
                                                    tablePreviousPage={previousPage}
                                                    tableCurrentPage={currentPage}
                                                    customePageSize={customePageSize}
                                                />
                                            </div>

                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Container>
                    </div>
                    {isPopupVisible && (
                        <PopupWindow message={popupMessage} type={popupType} onClose={closePopup} />
                    )}
                </React.Fragment>
            )
        }
    }
}

WorkingShifts.propTypes = {
    t: PropTypes.any,
};

export default withTranslation()(WorkingShifts);

